import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mock/data';

const Contact = () => {
  const contactDetails = [
    {
      icon: Phone,
      title: 'Phone',
      content: companyInfo.phone,
      link: `tel:${companyInfo.phone}`,
      linkText: 'Call Us Now'
    },
    {
      icon: Mail,
      title: 'Email',
      content: companyInfo.email,
      link: `mailto:${companyInfo.email}`,
      linkText: 'Send Email'
    },
    {
      icon: MapPin,
      title: 'Service Area',
      content: companyInfo.location,
      link: null,
      linkText: null
    },
    {
      icon: Clock,
      title: 'Business Hours',
      content: 'Mon - Fri: 8:00 AM - 6:00 PM\nSat: 9:00 AM - 4:00 PM',
      link: null,
      linkText: null
    }
  ];

  return (
    <section id="contact" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Contact Us</span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-2 mb-4">
            Let's Start Your Project
          </h2>
          <p className="text-lg text-slate-600">
            Get in touch with our team for a free consultation and quote
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {contactDetails.map((detail, index) => {
            const Icon = detail.icon;
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                  <Icon className="h-7 w-7 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-2">{detail.title}</h3>
                <p className="text-slate-600 mb-4 whitespace-pre-line">{detail.content}</p>
                {detail.link && (
                  <a
                    href={detail.link}
                    className="text-blue-600 hover:text-blue-700 font-medium inline-flex items-center gap-2 transition-colors duration-300"
                  >
                    {detail.linkText}
                    <span>→</span>
                  </a>
                )}
              </div>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-slate-800 rounded-2xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Space?
          </h3>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Contact us today for a free consultation and see how our expert team can bring your vision to life.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${companyInfo.phone}`}
              className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 shadow-lg inline-block"
            >
              Call: {companyInfo.phone}
            </a>
            <a
              href={`mailto:${companyInfo.email}`}
              className="px-8 py-4 bg-blue-700 text-white rounded-lg font-semibold hover:bg-blue-800 transition-all duration-300 transform hover:scale-105 shadow-lg inline-block"
            >
              Email: {companyInfo.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
